import React from 'react'
import './StepProgressBar.scss'
import Step from './Step/Step'

/**
 * This StepProgressBar component is exactly the same as simple StepProgressBar. The only difference is
 * that this component is being used on forms instead of dialog.
 * @component
 * @memberof Components
 * @returns {JSX.Element} The StepProgressBar component containing multiple steps.
 */

const StepProgressBar = (props) => {
    const steps = Array.isArray(props.array) ? props.array : [];
    const firstIncompleteIndex = steps.findIndex((item) => item.status !== 1);

    return (
        <div className="container-step">
            <div className="arrow-steps clearfix">
                {steps.map((item, index) => (
                    <Step
                        key={index}
                        number={index + 1}
                        title1={item.title1}
                        title2={item.title2}
                        status={item.status}
                        isCurrent={index === firstIncompleteIndex}
                        pageName={props.pageName}
                    />
                ))}
            </div>
        </div>
    )
}

export default StepProgressBar